<template>
  <div id="app">
    <WatermarkCommon>
      <router-view />
    </WatermarkCommon>
  </div>
</template>

<script>
export default {
  data(){
    return {
    }
  },
  mounted(){
  },
  methods: {
  }
}
</script>